// extracted by mini-css-extract-plugin
export default {"content":"c6c739"};